import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://keycloak.dingegno.com',
  realm: 'silabor',
  clientId: 'labs',
});

export default keycloak;